// extracted by mini-css-extract-plugin
export default {"dialog":"add-issue-fields-dialog-module__dialog--GpTED","dialogBody":"add-issue-fields-dialog-module__dialogBody--jDF_R"};